import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Stack, TextField } from '@mui/material';

type PrimitiveListInputProps = {
	type: 'string' | 'integer';
	value: any[] | null | undefined;
	onValueChange: (value: any[]) => void;
	readOnly?: boolean;
};

export default function PrimitiveListInput({ type, value, onValueChange, readOnly }: PrimitiveListInputProps) {
	const items: any[] = Array.isArray(value) ? value : [];

	const handleChange = (index: number, raw: string) => {
		const parsed = type === 'integer' ? (raw === '' ? '' : parseInt(raw, 10)) : raw;
		const updated = items.map((item, i) => (i === index ? parsed : item));
		onValueChange(updated);
	};

	const handleAdd = () => {
		onValueChange([...items, type === 'integer' ? 0 : '']);
	};

	const handleRemove = (index: number) => {
		onValueChange(items.filter((_, i) => i !== index));
	};

	return (
		<Stack spacing={0.5}>
			{items.map((item, index) => (
				<Stack key={index} direction="row" alignItems="center" spacing={0.5}>
					<TextField
						variant="standard"
						type={type === 'integer' ? 'number' : 'text'}
						value={item ?? ''}
						disabled={readOnly}
						onChange={(e) => handleChange(index, e.target.value)}
						fullWidth
						size="small"
					/>
					<IconButton size="small" onClick={() => handleRemove(index)} disabled={readOnly}>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</Stack>
			))}
			<IconButton size="small" onClick={handleAdd} sx={{ alignSelf: 'flex-start' }} disabled={readOnly}>
				<AddCircleIcon fontSize="small" />
			</IconButton>
		</Stack>
	);
}
